import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7099d1ce: FaireBrandEntity = {
  token: "b_7099d1ce",
  type: "brand",
  name: "BjornQorn",
  avatarUrl:
    "https://cdn.faire.com/fastly/eb2ed0c8b8f2fe791bd468fb085d63feddbf56b447a3d8b66eecbf05fc0562fb.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6d83758c002f98d352a09c57e7b4a4e251794ad3d39ec72e48b02341bee70c3c.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/eb2ed0c8b8f2fe791bd468fb085d63feddbf56b447a3d8b66eecbf05fc0562fb.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6d83758c002f98d352a09c57e7b4a4e251794ad3d39ec72e48b02341bee70c3c.webp",
  location: "Kerhonkson, NY, USA",
  minimumOrderDollars: 95,
  rating: 5,
  reviewCount: 90,
  isTopShop: true,
  isInsider: true,
  description:
    'BjornQorn is a family- and friend-owned & operated popcorn company based in the picturesque Hudson Valley of New York. Known for its unique, handcrafted popcorn, BjornQorn is made in a 100% solar-electric facility located inside Skate Time, a beloved local roller rink that the company purchased and revitalized in 2023. Combining the thrill of roller skating with the magic of a sustainable popcorn factory, our facility embodies innovation and fun. All of our popcorn is vegan, nutrient-fortified, and made using non-GMO kernels grown on Bjorn’s family farm in Minnesota and neighboring regenerative farm, Hudson Valley Farm Hub. With quirky packaging and a simple, transparent ingredient list, BjornQorn stands out as a snack that’s as delicious as it is environmentally conscious. Their "Classic" flavor, featuring nutritional yeast, has earned rave reviews, including being named “...the only packaged popcorn worth buying” by Bon Appétit.',
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:45.403Z",
    importedBy: "entity-db-cli",
  },
};
